import { gql } from '@apollo/client';

export const GET_BUILDABLE_TEMPLATE_TYPE_QUERY = gql`
    query GetBuildableTemplateType($buildableTemplateId: ID!) {
        buildableTemplate(id: $buildableTemplateId) {
            id
            templateType
        }
    }
`;
